import React, { Component } from "react";
import styles from "./reportContructor.module.scss";
import { withReportsList } from "../../../shared/containers/containerReportsList";
import { states } from "../../../reducers/queriesStates";
import { withCustomReport } from "../../../shared/containers/containerCustomReport";
import Preloader from "../../../shared/items/static/preloader";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import ButtonPrimary from "../../../shared/items/contols/buttonPrimary";
import FormControl from "@mui/material/FormControl";

class ReportConstructorPatternDashboard extends Component {
  constructor(props) {
    super(props);

    this.state = {
      dashboardId: null,
    };
  }

  componentDidUpdate(prevProps) {
    const { addCustomReportDahsboardDataState } = this.props;

    if (prevProps.addCustomReportDahsboardDataState === states.REQUEST && addCustomReportDahsboardDataState === states.READY) {
      this.setState({ dashboardId: null });
    }
  }

  onChange(e) {
    this.setState({ dashboardId: e.target.value });
  }

  onAdd() {
    const { selectedCustomReportId, onAddCustomReportDashboard } = this.props;
    const { dashboardId } = this.state;

    const options = { dashboardId, reportId: selectedCustomReportId };

    onAddCustomReportDashboard(options);
  }

  render() {
    const { dashboards, addCustomReportDahsboardDataState } = this.props;
    const { dashboardId } = this.state;

    return (
      <div className={styles.reportConstructorPatternDashboardsContainer}>
        <FormControl
          variant="standard"
          sx={{ m: 1, minWidth: 50, display: "inline-block", height: "30px" }}
          style={{ margin: "0px", padding: "3px" }}
        >
          <div>Доступные параметры:</div>
          <Select
            style={{ minWidth: "400px", margin: "0px" }}
            onChange={(e) => {
              this.onChange(e);
            }}
            placeholder={"Добавить дашборд"}
            value={dashboardId ?? ""}
          >
            {dashboards.map((x) => {
              return (
                <MenuItem key={x.id} value={x.id}>
                  {x.title}
                </MenuItem>
              );
            })}
          </Select>
        </FormControl>

        {addCustomReportDahsboardDataState === states.REQUEST ? (
          <Preloader />
        ) : dashboardId != null ? (
          <div className={styles.addToCustomReportBtnContainer}>
            <ButtonPrimary
              handleClick={() => {
                this.onAdd();
              }}
              title="Добавить в отчет"
            />
          </div>
        ) : null}
      </div>
    );
  }
}

export default withCustomReport(withReportsList(React.memo(ReportConstructorPatternDashboard)));
